module.exports = __webpack_public_path__ + "fonts/Mulish-MediumItalic.7b5ec967.ttf";